import type { CSSProperties } from 'react';
import type { AnalyticsGranularity, AnalyticsPeriod } from '../api/types';
import { granularityOptions, periodOptions } from './analyticsParams';

const row: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  alignItems: 'flex-end',
  marginBottom: 20,
};

const label: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: 14,
  color: '#374151',
};

const select: CSSProperties = {
  padding: '8px 12px',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  minWidth: 140,
  font: 'inherit',
};

export interface PeriodGranularityControlsProps {
  period: AnalyticsPeriod;
  onPeriodChange: (p: AnalyticsPeriod) => void;
  showGranularity?: boolean;
  granularity?: AnalyticsGranularity;
  onGranularityChange?: (g: AnalyticsGranularity) => void;
}

export function PeriodGranularityControls({
  period,
  onPeriodChange,
  showGranularity = false,
  granularity = 'daily',
  onGranularityChange,
}: PeriodGranularityControlsProps) {
  return (
    <div style={row}>
      <label style={label}>
        Period
        <select
          data-testid="analytics-period-select"
          style={select}
          value={period}
          onChange={(e) => onPeriodChange(Number(e.target.value) as AnalyticsPeriod)}
        >
          {periodOptions().map((p) => (
            <option key={p} value={p}>
              Last {p} days
            </option>
          ))}
        </select>
      </label>
      {showGranularity && onGranularityChange && (
        <label style={label}>
          Granularity
          <select
            data-testid="analytics-granularity-select"
            style={select}
            value={granularity}
            onChange={(e) => onGranularityChange(e.target.value as AnalyticsGranularity)}
          >
            {granularityOptions().map((g) => (
              <option key={g} value={g}>
                {g.charAt(0).toUpperCase() + g.slice(1)}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
}
